__turbopack_context__.v({
  "container": "cw76_q_container",
  "dropdownItem": "cw76_q_dropdownItem",
  "fadeInUp": "cw76_q_fadeInUp",
  "popup": "cw76_q_popup",
  "selected": "cw76_q_selected",
  "toggle": "cw76_q_toggle",
  "topEndPlacement": "cw76_q_topEndPlacement",
  "topStartPlacement": "cw76_q_topStartPlacement",
});
